import script from "./MoneyInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MoneyInput.vue?vue&type=script&setup=true&lang=js"

import "./MoneyInput.vue?vue&type=style&index=0&id=080b9723&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-080b9723"]])

export default __exports__